import Timetable from './components/timetable.svelte';  // Ensure this path is correct

const app = new Timetable({
    target: document.querySelector('program-new'),
});

export default app;
